import { Link } from '@tanstack/react-router'
import { ArrowRight } from 'lucide-react'

export function TextLink({ to, children }: { to: string; children: React.ReactNode }) {
  return (
    <Link to={to} className="group inline-flex min-h-6 items-center gap-1.5 text-sm font-medium text-primary underline-offset-4 hover:underline">
      {children}
      <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" aria-hidden="true" />
    </Link>
  )
}
